export interface IBiomarker {
    id: number;
    name: string;
    display: string;
    color: string;
    descriptions: string;
    isLabTest: boolean;
    isExternal: boolean;
    isPK: boolean;
}

export class Biomarker implements IBiomarker {
    id: number;
    name: string;
    display: string;
    color: string;
    descriptions: string;
    isLabTest: boolean;
    isExternal: boolean;
    isPK: boolean;

    constructor(data: IBiomarker) {
        this.id = data.id;
        this.name = data.name;
        this.display = data.display;
        this.color = data.color;
        this.descriptions = data.descriptions;
        this.isLabTest = data.isLabTest;
        this.isExternal = data.isExternal;
        this.isPK = data.isPK;
    }
} 